var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-form-container"},[_c('Logo'),_c('PasswordResetForm'),_c('p',{staticClass:"signup-link"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }